// 在代码加载后，同步 调用/api/env接口 获取当前后端机器环境 及 域名信息
// 以区分不同环境对应的 前端资源及服务地址 注入window 在后续代码逻辑中会使用
// 再添加 同类型资源时 要在这里进行设置
// 主要用于 区分 ali 和 tencent 索性把staing也拿过来统一处理了

function initEnv() {
  const orgId =
    /\/headhunters\/([^/]+)\/(org|job|recommend|update)/.exec(location.pathname)?.[1] ?? '';

  function injectToWindow(envs) {
    window._MOKA_ENV_ = { ...envs };
  }

  function getClientEnvFromSessionStorage() {
    const storage = window.sessionStorage.getItem('_MOKA_ENV_');
    if (storage) {
      try {
        const clientEnv = JSON.parse(storage);
        const { NODE_ENV, CLUSTER, VERSION, ORG_ID } = clientEnv;
        if (ORG_ID !== orgId) {
          return null;
        }

        if (NODE_ENV === 'staging' || VERSION !== process.env.RELEASE_TAG) {
          return null;
        }

        if (NODE_ENV && CLUSTER) {
          return clientEnv;
        }
      } catch (error) {
        // 跳过
        console.error(error);
        return null;
      }
    }
    return null;
  }

  function createXHR() {
    if (typeof window.XMLHttpRequest !== 'undefined') {
      return new window.XMLHttpRequest();
    } else if (typeof window.ActiveXObject !== 'undefined') {
      if (typeof arguments.callee.activeXString !== 'string') {
        const versions = [
          'Msxml3.XMLHTTP',
          'MSXML2.XMLHttp.6.0',
          'MSXML2.XMLHttp.3.0',
          'MSXML2.XMLHttp',
          'Microsoft.XMLHTTP',
        ];
        for (let i = 0, len = versions.length; i < len; i++) {
          try {
            const xhr = new window.ActiveXObject(versions[i]);
            arguments.callee.activeXString = versions[i];
            return xhr;
          } catch (ex) {
            // 跳过
          }
        }
      }
      return new window.ActiveXObject(arguments.callee.activeXString);
    } else {
      return null;
    }
  }

  function getClientEnvFromXHR() {
    try {
      const xhr = createXHR();
      if (!xhr) {
        return null;
      }

      xhr.open('GET', '/api/env', false); // 第一个参数指明访问方式，第二次参数是目标url，第三个参数是“是否异步”，true表示异步，false表示同步
      // 根据 orgId 获取环境变量，灰度问题
      if (orgId) {
        xhr?.setRequestHeader(
          'moka-tracing',
          JSON.stringify({ org_id: orgId, source: 'not-logged' })
        );
      }

      xhr.send();

      const { code, data } = JSON.parse(xhr.responseText);
      if (code === 0) {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  // 前端dev环境下 不看 sessionStorage 因为可能会切换代理服务器
  // staging 和 production 环境 会尝试从 sessionStorage 取 可以减少请求
  // 且不会长期存储，应对刷新就可以了
  const clientEnv =
    (process.env.NODE_ENV === 'production' && getClientEnvFromSessionStorage()) ||
    getClientEnvFromXHR();

  const {
    NODE_ENV = 'production',
    CLUSTER = 'prod',
    SOCKET_HOST = window.location.origin,
    PUBLIC_CDN,
    IS_OVERSEAS,
    LANGUAGE_PACK,
    IS_DINGTALK,
  } = clientEnv || {};

  if (process.env.NODE_ENV === 'production') {
    window.sessionStorage.setItem(
      '_MOKA_ENV_',
      JSON.stringify({
        ORG_ID: orgId,
        NODE_ENV,
        CLUSTER,
        VERSION: process.env.RELEASE_TAG,
        SOCKET_HOST,
        PUBLIC_CDN,
        IS_OVERSEAS,
        LANGUAGE_PACK,
        IS_DINGTALK,
      })
    );
  }

  if (NODE_ENV === 'production' || NODE_ENV === 'staging') {
    injectToWindow({
      ORG_ID: orgId,
      NODE_ENV,
      CLUSTER,
      SOCKET_HOST,
      PUBLIC_CDN,
      IS_OVERSEAS,
      LANGUAGE_PACK,
      IS_DINGTALK,
    });
  } else {
    // development
    injectToWindow({ NODE_ENV, CLUSTER });
  }
}

initEnv();
